import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, ArrowRight } from "lucide-react";
import http from "@/api";

export default function LuxuryUpgrade({ productId, lang, formatPrice }) {
  const [data, setData] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    let alive = true;
    http.post("/ai/luxury-upgrade", { product_id: productId, language: lang })
      .then((r) => { if (alive && r.data?.upgrade) setData(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, [productId, lang]);

  if (!data?.upgrade) return null;
  const nm = (p) => (lang === "ar" ? p.name_ar : p.name_en);

  return (
    <div className="rounded-2xl p-4 border-2 space-y-3" style={{ borderColor: "var(--secondary)", background: "var(--bg-subtle)" }}
         data-testid="luxury-upgrade">
      <div className="flex items-center gap-2 text-sm font-bold" style={{ color: "var(--primary)" }}>
        <Crown size={16} /> {lang === "ar" ? "رقِّها لنسخة أفخم" : "Upgrade to a finer version"}
      </div>
      <div className="flex items-center gap-2">
        <div className="text-center opacity-60">
          <img src={data.current.image} alt="" className="w-16 h-16 rounded-lg object-cover mx-auto" />
          <div className="text-[10px] mt-1">{lang === "ar" ? "الحالي" : "Current"}</div>
          <div className="text-xs font-semibold">{formatPrice(data.current.price_sar)}</div>
        </div>
        <ArrowRight size={18} className="opacity-50 rtl:rotate-180 shrink-0" />
        <button onClick={() => nav(`/p/${data.upgrade.id}`)} className="flex-1 flex items-center gap-2 rounded-xl p-2 bg-white border hover:border-[var(--primary)] text-start"
                style={{ borderColor: "var(--border)" }} data-testid="luxury-upgrade-go">
          <img src={data.upgrade.image} alt="" className="w-16 h-16 rounded-lg object-cover" />
          <div className="min-w-0">
            <div className="text-xs font-medium line-clamp-2">{nm(data.upgrade)}</div>
            <div className="text-sm font-bold" style={{ color: "var(--primary)" }}>{formatPrice(data.upgrade.price_sar)}</div>
          </div>
        </button>
      </div>
      <div className="text-xs opacity-75">{data.reason}</div>
      <button onClick={() => nav(`/p/${data.upgrade.id}`)} className="btn-primary w-full !py-2 text-sm" data-testid="luxury-upgrade-btn">
        <Crown size={14} /> {lang === "ar" ? `شاهد النسخة الأفخم (+${formatPrice(data.price_diff)})` : `See the finer version (+${formatPrice(data.price_diff)})`}
      </button>
    </div>
  );
}
